'use client'

export { DotEnvProvider, useDotEnv } from './context.tsx'
export type { DotEnv } from './dot-env.ts'
